import React, { useEffect, useState } from 'react';
import titlePng from '@/assets/images/title_icon.png';
import noInspectionPng from '../../../../../../imgs/no_inspection@2x.png';
import { Empty, Select } from '@maxtropy/components';
import { useRequest } from 'ahooks';
import styles from './index.module.scss';
import SubTitle from '@/pages/WgqAllMaps/components/SubTitle';
import { Spin } from 'antd';
import RecorderPreview from '@/components/RecorderPreview';
import {
  apiV2EnergyOverviewRecorderListPost,
  V2EnergyOverviewRecorderListPostResponse,
} from '@maxtropy/device-customer-apis-v2';

export type RecorderItem = Exclude<V2EnergyOverviewRecorderListPostResponse['list'], undefined>[number];

const InspectionRecorder = () => {
  const [selectedRecorder, setSelectedRecorder] = useState<RecorderItem>({});
  const { data, loading } = useRequest(apiV2EnergyOverviewRecorderListPost);

  useEffect(() => {
    if (data?.list?.length) {
      setSelectedRecorder(data.list[0]);
    }
  }, [data]);

  return (
    <div className={styles.container}>
      <SubTitle
        title="巡检记录仪"
        img={titlePng}
        style={{ paddingTop: 8 }}
        extraContent={
          <Select
            placeholder="请选择"
            style={{ width: 120 }}
            showSearch
            value={selectedRecorder.id}
            getPopupContainer={() => document.getElementById('full_screen_box') ?? document.body}
            optionFilterProp="label"
            onChange={value => {
              const selectedItem = data?.list?.find(item => item.id === value);
              setSelectedRecorder(selectedItem ?? {});
            }}
            options={
              data?.list?.map(i => ({
                label: i.deviceName,
                value: i.id,
              })) ?? []
            }
          />
        }
      >
        <Spin spinning={loading}>
          {selectedRecorder.id ? (
            <RecorderPreview item={selectedRecorder} hkDomPrefix="hk_energy_overview_inspection" />
          ) : (
            <Empty image={noInspectionPng} description="暂无巡检任务" style={{ paddingTop: 80 }} />
          )}
        </Spin>
      </SubTitle>
    </div>
  );
};

export default InspectionRecorder;
